import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/aldy/Downloads/kolabo 3/src/app/home/components/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/aldy/Downloads/kolabo 3/src/app/home/components/DashboardShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/aldy/Downloads/kolabo 3/src/app/home/components/FeatureModuleTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/aldy/Downloads/kolabo 3/src/app/home/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeLanguageProvider"] */ "/Users/aldy/Downloads/kolabo 3/src/app/home/components/HomeLanguageContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/aldy/Downloads/kolabo 3/src/app/home/components/PatchNotes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/aldy/Downloads/kolabo 3/src/app/home/components/PricingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/aldy/Downloads/kolabo 3/src/app/home/components/SocialProof.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/aldy/Downloads/kolabo 3/src/app/home/components/TrialForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/aldy/Downloads/kolabo 3/src/app/home/components/ValueProposition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/aldy/Downloads/kolabo 3/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/aldy/Downloads/kolabo 3/src/components/Header.tsx");
